/* Progressive enhancement: all information remains readable without JavaScript. */
if (!customElements.get('lmb-product-information')) {
  customElements.define('lmb-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const panels = [...this.querySelectorAll('[data-info-panel]')];
      if (!panels.length) return;
      this.dataset.ready = 'true';
      const nav = document.createElement('div');
      nav.className = 'lmb-information__tabs';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', this.dataset.label);
      const tabs = panels.map((panel, i) => {
        const tab = document.createElement('button');
        tab.type = 'button'; tab.id = panel.id + '-tab';
        tab.textContent = panel.querySelector('.lmb-information__fallback').textContent.trim();
        tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.addEventListener('click', () => select(i));
        nav.append(tab); return tab;
      });
      const select = (index, focus = false) => {
        panels.forEach((panel, i) => {
          panel.hidden = i !== index;
          tabs[i].setAttribute('aria-selected', String(i === index));
          tabs[i].tabIndex = i === index ? 0 : -1;
        });
        if (focus) tabs[index].focus({preventScroll: true});
        tabs[index].scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'instant'});
        // Existing read-more controls measure their panel when it becomes visible.
        window.dispatchEvent(new Event('resize'));
      };
      nav.addEventListener('keydown', event => {
        const current = tabs.indexOf(document.activeElement);
        if (current < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (current + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
      this.querySelector('.lmb-information__eyebrow').after(nav);
      // Initialise without moving the page to a section below the fold.
      panels.forEach((panel, i) => { panel.hidden = i !== 0; tabs[i].setAttribute('aria-selected', String(i === 0)); tabs[i].tabIndex = i === 0 ? 0 : -1; });
    }
  });
}
